import { req } from '../utils/request';

/**
 * 用户端活动模块 API。
 *
 * 覆盖活动展示、报名支付、我的订单、退款申请、发票申请和自主签到。
 */
export class Activity {
  // 活动列表和详情对未登录用户开放。
  list(params) {
    return req.get('user.activity/list', params);
  }
  detail(id) {
    return req.get('user.activity/detail', { id });
  }
  // 创建报名订单并返回支付参数。
  createOrder(params) {
    return req.post('user.activity/createOrder', params);
  }
  payStatus(orderNo) {
    return req.get('user.activity/payStatus', { order_no: orderNo });
  }
  // 我的活动订单。
  myOrders(params) {
    return req.get('user.activity/myOrders', params);
  }
  orderDetail(id) {
    return req.get('user.activity/orderDetail', { id });
  }
  // 退款和发票申请。
  applyRefund(params) {
    return req.post('user.activity/applyRefund', params);
  }
  invoiceSubmit(params) {
    return req.post('user.activity/invoiceSubmit', params);
  }
  invoiceList(params) {
    return req.get('user.activity/invoiceList', params);
  }
  // 公共签到码进入后，查询当前用户可签到订单并提交签到。
  checkinOrders(activityId) {
    return req.get('user.activity/checkinOrders', { activity_id: activityId });
  }
  checkin(params) {
    return req.post('user.activity/checkin', params);
  }
}

export default new Activity();
